// extracted by mini-css-extract-plugin
export default {"tooltip":"Uo-z","sharingV2":"Vo-z","sharingIconsV2":"Wo-z","links":"Xo-z","link":"Yo-z","facebookV2":"Zo-z","twitterV2":"_o-z","pinterestV2":"ap-z"};